import { Box, Tooltip, useColorMode, useColorModeValue } from '@chakra-ui/react'
import { Moon, Sun } from '@phosphor-icons/react'

const ColorModeSwitcher = () => {
    const { toggleColorMode } = useColorMode()
    const text = useColorModeValue("escuro", "claro")
    const SwitchIcon = useColorModeValue(Moon, Sun)

    return (
        <Tooltip label={`Trocar para tema ${text}`}>
            <Box cursor="pointer" onClick={toggleColorMode}>
                <SwitchIcon weight="fill" size={22} color="#FFF" />
            </Box>
        </Tooltip>
    )
}

export default ColorModeSwitcher